/**
 * @typedef {null | undefined} Nullish
 */

/**
 * Strict checking of value for null or undefined without coercion to Falsy/Truthy.
 * @param {unknown} val -
 * @returns {val is Nullish}
 */
export function isNullish(val) {
	return typeof val === "undefined" || val === null;
}
